module.exports = __webpack_public_path__ + "assets/img/guide.fe0b5508.svg";